import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";

function InspectiePagina() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
  title="Elektra inspectie - Elektraaanleggen.nl"
  description="Zorg voor een veilige elektrische omgeving in uw woning of bedrijfspand met onze professionele Elektra inspecties."
  schema={generateServiceSchema({
    name: "Elektra inspectie",
    description:
      "Onze Elektra inspectie zorgt voor een grondige controle van uw elektrische installatie, zodat u kunt vertrouwen op een veilige en betrouwbare stroomvoorziening. Wij werken volgens de hoogste veiligheidsnormen.",
    image: "https://elektraaanleggen.nl/images/banner.png",
  })}
/>

      <Header />
      <HeroSection
        title="Elektra Inspectie"
        description="Zorg voor een veilige elektrische omgeving in uw woning of bedrijfspand met onze professionele Elektra inspecties."
        imageSrc="/images/mark.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Waarom een elektra inspectie belangrijk is voor uw veiligheid
            </h2>
            <p>
              De veiligheid van de elektrische installatie in uw woning of
              bedrijfspand is van cruciaal belang. Het voldoen aan de normen van
              NEN 1010 en NEN 3140 is verplicht voor zowel nieuwe als bestaande
              installaties. Door periodieke inspecties te laten uitvoeren,
              voorkomt u risico’s zoals brandgevaar, elektrische schokken en
              storingen. Een keuringsrapport van een gecertificeerde inspecteur
              kan niet alleen uw veiligheid garanderen, maar ook uw verzekering
              dekt in geval van schade.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Gratis offerte
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-3/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/Inspectie-NEN-1010-1.jpg"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center">
          <div className="relative mx-auto bg-amber-100 px-5 py-3 w-full rounded-xl max-w-[1260px] lg:mb-12 lg:w-[calc(100%-2rem)] grid grid-cols-[1fr] gap-10 md:gap-12">
            <div>
              <h2 className="font-bold text-black text-xl mb-3">
                Wat u moet weten over de NEN 1010 en NEN 3140 normen
              </h2> 
              <p>
                De NEN 1010 norm stelt eisen aan de veiligheid van
                laagspanningsinstallaties die bij oplevering moeten worden
                nageleefd. De NEN 3140 norm richt zich op de veiligheid van
                installaties in gebruik. Beide normen vereisen periodieke
                inspecties om ervoor te zorgen dat uw elektrische installatie
                veilig blijft functioneren. Ons inspectierapport biedt u de
                gemoedsrust dat uw installatie voldoet aan de wetgeving en de
                vereiste certificering.
              </p>
            </div>
          </div>
        </div>

        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              De verantwoordelijkheid voor veiligheid in uw elektrische
              installatie
            </h2>
            <p>
              Als huurder of eigenaar van een pand, bent u verantwoordelijk voor
              de veiligheid van de elektrische installatie. De installatie moet
              voldoen aan de NEN 1010 en NEN 3140 normen. Door een
              gecertificeerde inspecteur in te schakelen, voorkomt u onveilige
              situaties en verzekert u zich van de noodzakelijke
              keuringsbewijzen. Onze inspecteurs helpen u om te voldoen aan de
              regelgeving en bieden u concrete aanbevelingen voor eventuele
              noodzakelijke aanpassingen.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Gratis offerte
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/groepenkast.png.jpeg"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele inspectie voor uw keuringsbewijs
            </h2>
            <p>
              Als u een keuringsbewijs nodig heeft voor uw elektrische
              installatie, zijn wij de experts die u nodig heeft. Wij zorgen
              ervoor dat uw installatie voldoet aan alle veiligheidseisen en
              verstrekken het keuringsbewijs dat nodig is voor compliance met de
              NEN-normen. Maak vandaag nog een afspraak voor een inspectie en
              krijg gemoedsrust dat uw installatie veilig is.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Gratis offerte
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="perilex aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/inspect.jpg"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <ServiceHighlights />
      <FAQ />

      <Reviews />
      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default InspectiePagina;
